import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-task-settings-page',
  templateUrl: './task-settings-page.component.html',
  styleUrls: ['./task-settings-page.component.scss']
})
export class TaskSettingsPageComponent {


}
